<div class="d-flex flex-row">
    <button
        type="button"
        class="campaign__action btn btn--paybee btn--outline-transparent caption dropdown-toggle"
        placement="bottom"
        [mdbPopover]="content"
        (popoverShown)="onPopoverShown()"
        (popoverHidden)="onPopoverHidden()"
        trigger="click"
        #popover="mdbPopover"
        style="border: 1px solid #D8D8D8; background: transparent; border-radius: 4px;"
    >
        <i class="fas fa-filter mr-2"></i>
        {{filterBtnText}}
    </button>
</div>

<ng-template #content >
    <ng-container *ngrxLet="categories$ as categories">
        <div class="popover-links">
            <div style="max-height: 250px; overflow-y: scroll;" class="custom-scroll-bar">
                <div  class="popover__action d-flex align-items-center cursor-pointer px-3 body-1 default" [ngClass]="activeItem == 1 ? 'active' : ' ' " (click)="onCategoryClick('All Items',1)">
                    All Items ({{categories.allItems}})
                </div>
               <div class="popover__action d-flex align-items-center cursor-pointer px-3 body-1 default"  [ngClass]="activeItem == 2 ? 'active' : ' ' " (click)="onCategoryClick('Items With No Bids',2)">
                    Items With No Bids ({{categories.noBidsItems}})
                </div>  
                <div class="popover__action d-flex align-items-center cursor-pointer px-3 body-1 default"  [ngClass]="activeItem == 3 ? 'active' : ' ' " (click)="onCategoryClick('Items Pending Payment',3)">
                    Items Pending Payment ({{categories.pendingItems}})
                </div>
                <div class="popover__action d-flex align-items-center cursor-pointer px-3 body-1 default"  [ngClass]="activeItem == 4 ? 'active' : ' ' " (click)="onCategoryClick('Paid Items',4)">
                    Paid Items ({{categories.paidItems}})
                </div>
                <div class="popover__action d-flex align-items-center cursor-pointer px-3 body-1 default"  [ngClass]="activeItem == 5 ? 'active' : ' ' " (click)="onCategoryClick('Unsold Items',5)">
                    Unsold Items ({{categories.unsoldItems}})
                </div>
                <div class="popover__action d-flex align-items-center cursor-pointer px-3 body-1 default"  [ngClass]="activeItem == 6 ? 'active' : ' ' " (click)="onCategoryClick('Sold Out Items',6)">
                    Sold Out Items ({{categories.soldOutItems}})
                </div>
                <div class="popover__action d-flex align-items-center cursor-pointer px-3 body-1 default"  [ngClass]="activeItem == 7 ? 'active' : ' ' " (click)="onCategoryClick('Items With No Activity (Bid/Buy)',7)">
                    Items With No Activity (Bid/Buy) ({{categories.noActivityItems}})
                </div>
                <ng-container *ngFor="let category of categories.custom | keyvalue; let idx = index">
                    <div class="popover__action d-flex align-items-center cursor-pointer px-3 body-1" [ngClass]="activeItem == idx + 8 ? 'active' : ' ' " (click)="onCategoryClick(category.key,idx + 8)">
                        {{category.key}} ({{category.value}})
                    </div> 
                </ng-container>
            </div>
        </div>
    </ng-container>
</ng-template>